import {Injectable} from '@angular/core';
import {LoginEvent} from '../model/login-event';
import {LoginService} from '../components/login/login.service';
import {CanActivate} from '@angular/router';

@Injectable()
export class UserGuardService implements CanActivate{

  private loginEvent : LoginEvent = {isUserLogged:false, isAdmin:false, isClient:false, sharedReportId: null, singleReportId: null};

  constructor(private loginService : LoginService) {
  }

  canActivate() : boolean {
    this.loginEvent = this.loginService.getLoginData();
    return (this.loginEvent.isUserLogged && this.loginEvent.isClient);
  }
}
